export default __webpack_public_path__ + "static/media/Dan-Cates.efd63f3f.png";